import { render, staticRenderFns } from "./PzFadSdkForm.vue?vue&type=template&id=39529162"
import script from "./PzFadSdkForm.vue?vue&type=script&lang=js"
export * from "./PzFadSdkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39529162')) {
      api.createRecord('39529162', component.options)
    } else {
      api.reload('39529162', component.options)
    }
    module.hot.accept("./PzFadSdkForm.vue?vue&type=template&id=39529162", function () {
      api.rerender('39529162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Fad2/PzFadSdkForm.vue"
export default component.exports